import { render, staticRenderFns } from "./prizeGrant.vue?vue&type=template&id=4a0f63a8"
import script from "./prizeGrant.vue?vue&type=script&lang=js"
export * from "./prizeGrant.vue?vue&type=script&lang=js"
import style0 from "./prizeGrant.vue?vue&type=style&index=0&id=4a0f63a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports